import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../../theme';
import { dropdownWithTriangle } from '../../styles/dropdownMixins';

export const useMonitorJobMapStyles = createStyles(
  ({ token }, { trackVertical } = {}) => ({
    mapDropdownMenuOverlay: {
      ...dropdownWithTriangle({
        dropdownPrefix: 'ant-popover',
        menuSelector: '.ant-popover-content',
        menuItemPrefix: 'ant-menu',
        menuCustom: { width: 'auto' },
      }),

      '&.ant-popover': {
        paddingTop: 0,

        '.ant-popover-inner': {
          borderRadius: 'inherit',
          overflow: 'hidden',
          boxShadow: 'none',
          backgroundColor: 'transparent',
        },
      },
      '.ant-popover-arrow': {
        display: 'none',
      },
      '.ant-popover-inner-content': {
        padding: 0,
      },

      '.ant-menu': {
        borderWidth: 0,
        backgroundColor: 'transparent',
      },
      '.ant-menu .ant-menu-item': {
        padding: 0,
        fontSize: token.fontSize,
        lineHeight: '25px',
        fontWeight: 500,
        width: 'auto',

        '.map-dropdown-menu-overlay-item': {
          display: 'inline-flex',
          gap: ThemeSpaces.SPACE_XS,

          '.menu-overlay-item-limited-chars': {
            color: 'inherit',
            maxWidth: '12ch',
          },
        },
      },
      [`.${trackVertical}`]: {
        zIndex: 1,
        right: 0,
      },
    },
    activityIndicator: {
      display: 'flex',
      alignItems: 'center',

      '&:first-child': {
        marginLeft: ThemeSpaces.SPACE_NORM,
      },

      '.CustomGPSIcon': {
        justifyContent: 'center',
        lineHeight: 1,
        gap: ThemeSpaces.SPACE_XXS,

        'span:last-child': {
          marginTop: '0 !important',
        },
      },
    },
  })
);
